import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useContext } from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, IconButton } from '@mui/material';
import ModalContext from '../ModalContext.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var _excluded = ["className"];
var componentCloseIcon = createComponentSlot({
  name: "CinModal",
  slot: "CloseIcon"
});

var CloseIconButtonBase = function CloseIconButtonBase(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useContext = useContext(ModalContext),
      onCancel = _useContext.onCancel,
      closeIcon = _useContext.closeIcon;

  if (!onCancel || !closeIcon) return null;
  return /*#__PURE__*/React.createElement(IconButton, _extends({
    "aria-label": "close"
  }, props, {
    className: classnames(componentCloseIcon.className, className),
    onClick: onCancel
  }), closeIcon);
};

var CloseIconButton = styled(CloseIconButtonBase, _objectSpread2(_objectSpread2({}, componentCloseIcon.styledOptions), {}, {
  skipSx: true,
  skipVariantsResolver: true
}))({
  position: "absolute",
  right: 12,
  top: 12
});
var CloseIconButton$1 = CloseIconButton;

export { CloseIconButton$1 as default };
